import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  orderStatus,
  systemDiscount,
} from "../../../assets/constants/constant";
import moment from "moment";
import { trackingNumberCopy } from "../../../helpers";
import { Tooltip } from "antd";
import CopyToClipboard from "react-copy-to-clipboard";
import { CopyOutlined } from "@ant-design/icons";

const OrderSummary = ({ orderDetail, shippingCharge }) => {
  const { total_amount } = useSelector((state) => state.cart);
  const param = useParams();

  return (
    <div>
      <div className="cartTotals form-control mb-3">
        <div className="row ">
          <div className="col-6   ">
            <h6>Sub Total:</h6>
          </div>
          <div className="col-6 text-end">
            <span className="text-end fw-600">
              ${orderDetail?.subTotal?.toFixed(2)}
            </span>
          </div>
        </div>

        <div className="row pt-1">
          <div className="col-7">
            <h6>Shipping Charges:</h6>
          </div>
          <div className="col-5 text-end ">
            <span className="text-end fw-600">
              ${orderDetail?.shippingCharge?.toFixed(2)}
            </span>
          </div>
        </div>

        {orderDetail?.discountedAmount > 0 && (
          <div className="row pt-1">
            <div className="col-7">
              <h6>
                {" "}
                {orderDetail?.discountApplied === systemDiscount?.itemdiscount
                  ? "Items"
                  : "Coupon"}{" "}
                Discount:
              </h6>
            </div>
            <div className="col-5 text-end ">
              <span className="text-end text-success fw-600">
                -$
                {orderDetail?.discountedAmount?.toFixed(2)}
              </span>
            </div>
          </div>
        )}

        {orderDetail?.rewardPoints > 0 && (
          <div className="row pt-1">
            <div className="col-7">
              <h6>Rewards Used:</h6>
            </div>
            <div className="col-5 text-end ">
              <span className="text-end text-success fw-600">
                -$
                {orderDetail?.rewardPoints}
              </span>
            </div>
          </div>
        )}
        <hr className="my-2" />
        <div className="row pt-1">
          <div className="col-6">
            <h6 className="ad-text-dark">Total Amount:</h6>
          </div>

          <div className="col-6 text-end">
            <span className="fw-bold">${orderDetail?.total?.toFixed(2)}</span>
          </div>
        </div>

        <div className="row ">
          <div className="col-6">
            <h6 className="ad-text-dark">Status:</h6>
          </div>

          <div className="col-6 text-end">
            {orderDetail?.orderStatus === orderStatus?.pending ? (
              <span className="text-warning">Pending</span>
            ) : orderDetail?.orderStatus === orderStatus?.delivered ? (
              <span className="color-green">Delivered</span>
            ) : orderDetail?.orderStatus === orderStatus?.cancelled ? (
              <span className="text-danger">Cancelled</span>
            ) : (
              <></>
            )}
          </div>
        </div>

        {orderDetail?.orderStatus === orderStatus?.delivered && (
          <div className="row ">
            <div className="col-6">
              <h6 className="ad-text-dark">Delivery Date:</h6>
            </div>

            <div className="col-6 text-end">
              <span>
                {moment(new Date(orderDetail?.deliveryDate)).format("llll")}
              </span>
            </div>
          </div>
        )}

        {orderDetail?.trackingId && (
          <div className="row ">
            <div className="col-6">
              <h6 className="ad-text-dark">Tracking Number</h6>
            </div>
            <div className="col-6 text-end">
              <CopyToClipboard
                onCopy={() => trackingNumberCopy(orderDetail?.trackingId)}
                text={orderDetail?.trackingId}
              >
                <Tooltip title="Copy Tracking Number" placement="bottom">
                  <p>
                    <span>{orderDetail?.trackingId}</span> <CopyOutlined />
                  </p>{" "}
                </Tooltip>
              </CopyToClipboard>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderSummary;
